import { SidebarContentType } from "../KnowledgeBaseSidebar"
import SampleQuestionsAction from "./SampleQuestionsAction/SampleQuestionsAction"

export interface SidebarActionsProps {
    openSidebar: () => void
    type?: SidebarContentType
}

const SidebarActionsSelector = (props: SidebarActionsProps) => {
    const { type, openSidebar } = props
    const renderActions = () => {
        switch (type) {
            case SidebarContentType.sampleQuestions:
                return <SampleQuestionsAction openSidebar={openSidebar} />
            default:
                return <></>
        }
    }
    return renderActions()
}

export default SidebarActionsSelector
